import React from "react";
import HOC from "../../components/HOC";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";
import BreadcrumbBillingManual from "../../components/screen/billingManual/BreadcrumbBillingManual";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";
import CreateBillingManual from "../../components/screen/billingManual/CreateBillingManual";

const BillingManualDetailPOPage = ({ isWarehouse }) => {
  return (
    <div className="">
      <PageTemplate
        header={(isWarehouse ? "Central Warehouse " : "") + "Buat Billing  Manual"}
        mainComponent={
          <ThemeProvider theme={theme}>
            <CreateBillingManual
              isWarehouse={isWarehouse ? isWarehouse : false}
            />
          </ThemeProvider>
        }
        breadcrumb={
          <BreadcrumbBillingManual
            isWarehouse={isWarehouse ? isWarehouse : false}
          />
        }
        pageRole={isWarehouse ? 28 : 7}
        noPadding={true}
      />
    </div>
  );
};

export default HOC(BillingManualDetailPOPage);
